import { useEffect, useRef } from "react";
import { subscribeToVehicleState } from "@/services/incidentService";

export function useVehicleStateSocket(callback) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    const unsubscribe = subscribeToVehicleState((vehicleStateData) => {
      if (typeof callbackRef.current === "function") {
        callbackRef.current(vehicleStateData);
      }
    });

    return () => {
      unsubscribe?.();
    };
  }, []);
}
